// extracted by mini-css-extract-plugin
export default {"statusTooltipContainer":"RentalDetailsRentalInfo_statusTooltipContainer__j3u86","tiiLink":"RentalDetailsRentalInfo_tiiLink__9EBdj"};